export class QuickPromptsPageController {
  selectPrompt(
    prompt: string,
    onSelect: (prompt: string) => void
  ): void {
    onSelect(prompt);
  }

  resolvePromptToCopy(
    currentPrompt: string,
    fallbackPrompt: string
  ): string {
    return currentPrompt.trim() ? currentPrompt : fallbackPrompt;
  }
}